<template>
  <div class="col-25" v-lazyload>
    <span>{{ index }}</span>
    <img :data-srcset="highlight.imageSourceSet" :data-src="highlight.imageSource" :alt="highlight.title" :title="highlight.title"/>
    <p>
      {{highlight.description}}
    </p>
  </div>
</template>

<script>

export default {
  name: "ProductViewDetailsHighlights",
  props: {
    highlight: Object,
    index: Number
  },
}
</script>

<style lang="scss" scoped>
.details-details span {
  width: 30px;
  height: 30px;
  border-radius: 30px;
  background: #333;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
}

.details-details p {
  padding-top: 20px;
  font-size: 14px;
  line-height: 1.55em;
}

</style>
